import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EncuestaCovidEntity, ServicioEncuestaCovidService, EncuestaCovidRealizadasEntity } from '../../../services/servicio-encuesta-covid.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-encuesta-covid',
  templateUrl: './header-encuesta-covid.component.html',
  styleUrls: ['./header-encuesta-covid.component.css']
})
export class HeaderEncuestaCovidComponent implements OnInit {

  encuestaReliazada: number;
  downloading: boolean;
  loading: boolean;

  mensajeLoading: string;
  mensajeError: string; // Mensaje de error

  encuestasRealizadas: EncuestaCovidRealizadasEntity[] = [];

  @Input() public objetoEncuesta: EncuestaCovidEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;

  constructor( private servicioEncuesta: ServicioEncuestaCovidService) {
    this.filtrosSeleccionados = new EventEmitter();
  }

  ngOnInit() {
    this.encuestaReliazada = -1;
    this.getEncuestasRealizadas();
  }

  async getEncuestasRealizadas() {
    try {
      this.loading = true;
      this.mensajeLoading = 'Cargando encuestas realizadas ...';
      console.log(this.mensajeLoading);
      const response = await this.servicioEncuesta.getEncuestasRealizadas(this.objetoEncuesta);
      response.subscribe((data: EncuestaCovidRealizadasEntity[]) => {
        this.encuestasRealizadas = data;
        if(data && data.length > 0){
          this.encuestaReliazada = data[0].id;
          this.onGenerar();
          this.loading = false;
          this.mensajeLoading = null;
        } else {
          this.mensajeError = 'El paciente no presenta encuestas realizadas.';
          this.loading = false;
          this.mensajeLoading = null;
        }
      }, (err: HttpErrorResponse) => {
        this.encuestasRealizadas = [];
        this.loading = false;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al intentar obtener encuestas, verifique conexión a internet. De lo contrario reporte caso al administrador';
        console.error('Header-Encuesta-Covid.getEncuestasRealizadas()', err);
      });
    } catch(e) {
      this.encuestasRealizadas = [];
      this.loading = false;
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al intentar obtener encuestas, verifique conexión a internet. De lo contrario reporte caso al administrador';
      console.error('Header-Encuesta-Covid.getEncuestasRealizadas()', e);
    }
  }

  onGenerar() {
    this.encuestaReliazada = Number(this.encuestaReliazada);
    if(this.encuestaReliazada === -1) {
      this.mostrarMensaje('Debe seleccionar una encuesta realizada.');
    } else {
      this.objetoEncuesta.encuesta = this.encuestasRealizadas.find((e: EncuestaCovidRealizadasEntity) => e.id === this.encuestaReliazada);
      this.filtrosSeleccionados.emit(this.objetoEncuesta);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    var left = (screen.width/2) - (screen.width / 4);
    printContents = document.getElementById('encuesta-print').innerHTML;
    popupWin = window.open('', '_blank', `height=800px,width=1200px,left=${left}`);
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarPDF() {

  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 3500);
  }

}
